
import { ContentType } from "modules/sharing/models";

//Performs all the required encoding and URL formatting for an email/mailto link.
//Please note: mailto links do not respect links, and only expect plaintext.
export const generateMailTo = (subject: string, body: string, link?: string) => {
    const encodedSubject = encodeURI(subject);
    const encodedBody = encodeURI(body);
    let mailToUrl = `mailto:?subject=${encodedSubject}&body=${encodedBody}`;

    if(link) {
        //%0A is an encoded /n
        mailToUrl += `%0A%0A${link}`;
    }

    return mailToUrl;
}

export const getDefaultEmailSubject = (contentType: ContentType, tenantName: string, contentTitle: string = "") => {
    switch(contentType) {
        case ContentType.Event:
            return `Sharing this event from ${tenantName}`;

        case ContentType.Post:
            return `${tenantName}: ${contentTitle}`;
    }
}

export const getDefaultEmailBody = (contentType: ContentType, tenantName: string) => {
    switch(contentType) {
        case ContentType.Event:
            return `Check out this event in ${tenantName}:`

        case ContentType.Post:
        default:
            return `Check out this post in ${tenantName}:`
    }
}

export const getTwitterLink = (encodedText: string) => {
    return (`https://twitter.com/intent/tweet?text=${encodedText}`);
}

export const getLinkedInLink = (encodedText: string) => {
    return (`https://www.linkedin.com/feed/?shareActive=true&text=${encodedText}`);
}

export const getFacebookLink = (encodedText: string) => {
    return (`https://www.facebook.com/sharer/sharer.php?u=${encodedText}`);
}

//Generates our generic message + link as a single string and encodes it - Put it on the end of share urls.
export const createBodyAndEncode = (tenantName: string, shareUrl: string) => {
    const plainBody = `Check out this post in ${tenantName}:\n\n${shareUrl}`;
    return encodeURI(plainBody);
}

//EncodeURIComponent is used for facebook, as it requires the share link in its entirety (including https://) to be encoded.
//Some websites don't allow for prewritten body texts as well, so this one is just the link.
export const createBodyAndEncodeOnlyUrl = (shareUrl: string) => {
    return encodeURIComponent(shareUrl);
}